import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import AdditionalMenuExample from '../examples/AdditionalMenu';
import DocFullScreenExample from '../UI/DocFullScreenExample';
const AdditionalMenuExampleSource = require('!!raw-loader!../examples/AdditionalMenu');
const AdditionalMenuPage = () => (<div>
        <Helmet title="AdditionalMenu"/>
        <h3>AdditionalMenu</h3>
        <DocFullScreenExample className="px-11 overflow-auto">
            <AdditionalMenuExample />
        </DocFullScreenExample>
        <pre>
            <PrismCode className="language-jsx">{AdditionalMenuExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`
AdditionalMenu.propTypes = {
  actionButton?: Element<typeof Button>,
  links: [
    {|
      name: string,
      title: string,
    |},
  ],
};
`}
                </PrismCode>
            </pre>
        </div>
    </div>);
export default AdditionalMenuPage;
